<script setup lang="ts">
import Button from 'primevue/button'

import { mergeClassNames } from '#utils'

import type { RButtonProps } from './RButton.types.ts'

const props = defineProps<RButtonProps>()
</script>

<template>
  <Button
    v-bind="$props"
    :icon-class="mergeClassNames(props.iconClass, 'iconify')"
    :unstyled="false"
  >
    <slot />
  </Button>
</template>

<style src="./RButton.css"></style>
